import React from "react";
import { BsThreeDotsVertical } from "react-icons/bs";
import { Menu } from "@mui/material";
import { usePopupState, bindTrigger, bindMenu } from "material-ui-popup-state/hooks";
import ContextMenu, { ViewGroupOptions } from "./ContextMenu";

interface SettingButtonProps {
	setViewGroups: React.Dispatch<React.SetStateAction<ViewGroupOptions[]>>;
	viewGroups: ViewGroupOptions[];
}

export default function SettingButton(props: SettingButtonProps) {
	const popupState = usePopupState({ variant: "popover" });

	return (
		<>
			<button
				className={
					"flex cursor-pointer items-center rounded-md border border-transparent    transition-colors hover:bg-gray-100 active:bg-gray-100 p-1  " +
						(popupState.isOpen ? "bg-gray-100 hover:bg-gray-100" : "")
				}
				{...bindTrigger(popupState)}
			>
				<BsThreeDotsVertical size={19} />
			</button>

			<Menu
				{...bindMenu(popupState)}
				anchorOrigin={{
					vertical: "bottom",
					horizontal: "right",
				}}
				transformOrigin={{
					vertical: "top",
					horizontal: "right",
				}}
			>
				<ContextMenu
					isOpen={true}
					viewGroups={props.viewGroups}
					setViewGroups={props.setViewGroups}
				/>
			</Menu>
		</>
	);
}
